import React, { useState } from "react";
import { useSelector } from "react-redux";
import hash from "object-hash";
import { useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import HereMap from "./HereMap";
import PlotsPluginHereMap from "./plugins/plots";
import NTMSelect from "components/Buttons/NTMSelect";
import ElementModal from "../Modal/ElementModal";
import { AGRISMART, deleteElem, getErrorMessage, PARCELS, post, put } from "../../service/Client";
import { roles } from "../../constants";
import style from "./heremap.module.scss";


export default function AgrismartMap({parcels, markers, devices}) {
	let user = useSelector(store => store.users.data)
	const [center, setCenter] = useState()
	const [selectedTrackerDevice, setSelectedTrackerDevice] = useState("")
	const [editingParcel, setEditingParcel] = useState("")
	const [editMode, setEditMode] = useState()
	const plotsPlugin = PlotsPluginHereMap()
	const queryClient = useQueryClient()
	const {enqueueSnackbar} = useSnackbar()
	const plotsPluginInitialData = _createInitialPlots()
	const zoom = 18

	if(markers && markers.length > 0 && !center) setCenter({lat:markers[0].lat, lng:markers[0].lng})

	const parcelsModalSelectOptions = devices.map(d => d.device)

	function showError(e) {
		enqueueSnackbar(getErrorMessage(e), {variant: "error"})
	}

	function _createInitialPlots() {
		return parcels.map(parcel => {
			let coord

			try {
				coord = JSON.parse(parcel.area)
			} catch (e) {
				console.log("It's not possible to parse parcel", e.message)
			}

			return {
				coord,
				tracker: parcel.device,
				originalData: parcel
			}
		})
	}
	function onSubmitParcel() {
		const parcelDto = {
			area: editingParcel.coord,
			crop: "uva",
			device: selectedTrackerDevice
		};

		if (!roles.isAdmin(user)) return
		if(editMode) {
			return put(`${AGRISMART}/${PARCELS}/${editingParcel.id}`, { body: parcelDto })
				.then(() => queryClient.invalidateQueries('parcels'))
				.finally(() => {
					setSelectedTrackerDevice("")
					setEditingParcel(null)
					setEditMode(false)
				})
		}

		return post(`${AGRISMART}/${PARCELS}`, { body: parcelDto })
			.then(() => queryClient.invalidateQueries('parcels'))
			.catch(showError)
			.finally(() =>{
				setSelectedTrackerDevice("")
				setEditingParcel(null)
			})
	}

	function onParcelClick(editingParcel) {
		if (!roles.isAdmin(user)) return
		setEditingParcel(editingParcel)
		setEditMode(true)
		setSelectedTrackerDevice(editingParcel.tracker)
	}

	function onParcelRemoved (deletingParcel) {
		if (!roles.isAdmin(user)) return
		deleteElem(`${AGRISMART}/${PARCELS}/${deletingParcel.originalData.id}`)
			.then(() => queryClient.invalidateQueries('parcels'))
			.catch(showError)
	}

	function onParcelChange (updatedParcel) {
		if (!roles.isAdmin(user)) return
		const { originalData } = updatedParcel
		originalData.area = updatedParcel.coord
		put(`${AGRISMART}/${PARCELS}/${originalData.id}`, { body: originalData })
			.then(() => queryClient.invalidateQueries('parcels'))
			.catch(showError)
	}

	function onParcelCreated(parcel) {
		if (!roles.isAdmin(user)) return
		setEditingParcel(parcel)
	}

	function onTrackerSelected (event) {
		setSelectedTrackerDevice(event.target.value)
	}

	function onModalClose() {
		if (!editMode) {
			plotsPlugin.mutatePlots.remove(editingParcel.mapObj)
		}
		setEditingParcel(null)
		setSelectedTrackerDevice("")
		setEditMode(false)
	}

	return <>
		<HereMap
			key={hash(parcels)}
			center={center || { lat:40.967320,	lng:17.115670 }}
			zoom={zoom}
			theme={"normal.day"}
			markers={markers}
			className={style.map}
			plugins={[
				plotsPlugin.initPlugin({
					onPlotClick: onParcelClick,
					onPlotCreated: onParcelCreated,
					onPlotChange: onParcelChange,
					onPlotRemoved: onParcelRemoved,
					setCenter: center => setCenter(center),
					initialData: plotsPluginInitialData
				})
			]}
		/>
		<ElementModal
			isOpen={!!editingParcel}
			onClose={onModalClose}
			reset={onModalClose}
			submit={onSubmitParcel}
			submitButtonDisabled={!selectedTrackerDevice && !editMode}
		>
			<NTMSelect onChange={onTrackerSelected} value={selectedTrackerDevice}>
				<option value="" disabled>Seleziona la centralina da associare</option>
				{parcelsModalSelectOptions.map((option, i) => (
					<option key={`${option}-parcel-option`} value={option}>
						{option}
					</option>
				))}
			</NTMSelect>
		</ElementModal>
	</>
}
